const appendStylesToHead = (css) => {
    const head = document.head || document.getElementsByTagName('head')[0];
    const style = createStyleElement(css);

    head.appendChild(style);
};

const createLinkElement = (stylesUrl) => {
    const linkElement = document.createElement('link');
    linkElement.setAttribute('data-bf-widget', 'true');
    linkElement.href = stylesUrl;
    linkElement.rel = 'stylesheet';

    return linkElement;
};

const createStyleElement = (css) => {
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.setAttribute('data-bf-widget', 'true');
    style.appendChild(document.createTextNode(css));

    return style;
};

export const removeStylesUrl = () => {
    const preExistingElement = document.querySelector('link[data-bf-widget="true"]');

    if (preExistingElement) {
        preExistingElement.parentNode.removeChild(preExistingElement);
    }
};

export const removeStylesInHead = () => {
    const preExistingElement = document.querySelector('style[data-bf-widget="true"]');

    if (preExistingElement) {
        preExistingElement.parentNode.removeChild(preExistingElement);
    }
};

export const replaceStylesInHead = (css) => {
    const preExistingElement = document.querySelector('style[data-bf-widget="true"]');

    if (preExistingElement) {
        preExistingElement.innerHTML = css;
    } else {
        const style = createStyleElement(css);
        const head = document.head || document.getElementsByTagName('head')[0];
        head.appendChild(style);
    }
};

export const appendStylesLinkToHead = (stylesUrl) => {
    const head = document.head || document.getElementsByTagName('head')[0];
    const linkElement = createLinkElement(stylesUrl);

    head.appendChild(linkElement);
};

export const replaceStylesLink = (stylesUrl, onLoad) => {
    const preExistingElement = document.querySelector('link[data-bf-widget="true"]');
    const linkElement = createLinkElement(stylesUrl);

    const loadCb = typeof onLoad === 'function' ? onLoad : () => {};

    if (preExistingElement) {
        const href = preExistingElement.href;

        if (href === stylesUrl) {
            return;
        }

        linkElement.addEventListener('load', () => {
            document.head.removeChild(preExistingElement);
            onLoad();
        });

        preExistingElement.parentNode.insertBefore(
            linkElement,
            preExistingElement.nextSibling,
        );
    } else {
        linkElement.addEventListener('load', loadCb);
        document.head.appendChild(linkElement);
    }

};

export const appendScriptToHead = (script, className) => {
    const head = document.head || document.getElementsByTagName('head')[0];
    if (head.getElementsByClassName(className).length === 0) {
        const element = document.createElement('script');
        element.type = 'text/javascript';
        element.src = script;
        element.className = className;
        head.appendChild(element);
    }
};

export default appendStylesToHead;
